import React from "react";
import Tabs from "../components/MyCompany/Navigation";
import { Headers } from "../components/ui/heading";
import { HiUsers } from "react-icons/hi2";
import { useGetMerchantProfile } from "../hooks/queries/useMerchantQueries";
import { useGetAllMerchantUsersQuery } from "../hooks/queries/useProfileQueries";
import { Paper } from "@mantine/core";

function CompanyDetails() {
  const { data: merchantProfile, isLoading, isError } = useGetMerchantProfile();
  const { data: merchantUsers } = useGetAllMerchantUsersQuery();

  const companyName =
    isLoading || isError
      ? "My Company"
      : merchantProfile?.merchantName || "My Company";

  return (
    <div className="min-h-screen flex flex-col pb-16">
      <Paper shadow="xs" p={{ base: "sm", sm: "xl" }}>
        <div className="mb-2 sm:mb-4 flex-shrink-0">
          <Headers
            name={companyName}
            additionalInfo={
              <span className="flex items-center gap-2 text-sm text-gray-600">
                <HiUsers className="text-lg" />
                {merchantUsers ? merchantUsers.length : 0} Users
              </span>
            }
          />
        </div>
        <div className="flex-1">
          <Tabs />
        </div>
      </Paper>
    </div>
  );
}

export default CompanyDetails;
